/**
 * Système de Remises Gamifié - Boutique du Plaisir
 * Version améliorée avec meilleure détection et affichage
 */

class DiscountGamification {
  constructor() {
    this.levels = [
      { threshold: 100, discount: 5, name: 'Bronze', emoji: '🥉', color: 'bronze' },
      { threshold: 200, discount: 10, name: 'Argent', emoji: '🥈', color: 'silver' },
      { threshold: 300, discount: 15, name: 'Or', emoji: '🥇', color: 'gold' },
      { threshold: 400, discount: 20, name: 'Platine', emoji: '💎', color: 'platinum' },
      { threshold: 500, discount: 25, name: 'Diamant', emoji: '💎✨', color: 'diamond' }
    ];
    
    this.cartTotal = 0;
    this.currentLevel = null;
    this.nextLevel = null;
    this.container = null;
    this.initialized = false;
    
    // Initialisation immédiate
    this.init();
  }
  
  init() {
    // Attendre que le DOM soit prêt
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }
  
  setup() {
    console.log('Discount gamification: Setting up...');
    
    // Toujours créer le widget sur les pages appropriées
    this.createDiscountWidget();
    this.updateCartTotal();
    this.bindEvents();
    this.initialized = true;
    
    console.log('Discount gamification: Setup complete');
  }
  
  isCartPage() {
    // Pages de panier
    const isCartPage = window.location.pathname === '/cart' || 
                      window.location.pathname.endsWith('/cart') ||
                      document.querySelector('.section--main-cart') !== null;
    
    return isCartPage;
  }
  
  isCollectionPage() {
    // Pages de collection
    return window.location.pathname.includes('/collections/') ||
           document.querySelector('.section--main-collection') !== null;
  }
  
  isProductPage() {
    // Pages produit
    return window.location.pathname.includes('/products/') ||
           document.querySelector('.section--main-product') !== null;
  }
  
  createDiscountWidget() {
    // Différents types d'affichage selon la page
    if (this.isCartPage()) {
      this.createCartWidget();
    } else if (this.isCollectionPage()) {
      this.createCollectionWidget();
    } else if (this.isProductPage()) {
      this.createProductWidget();
    }
    
    // Toujours créer le widget pour le panier latéral
    this.createDrawerWidget();
  }
  
  createCartWidget() {
    const targetContainer = document.querySelector('#discount-gamification-container-empty') ||
                           document.querySelector('.order-summary') ||
                           document.querySelector('form[action*="cart"]') ||
                           document.querySelector('.cart-items');
    
    if (!targetContainer) return;
    
    this.container = document.createElement('div');
    this.container.className = 'discount-gamification discount-gamification--cart';
    this.container.innerHTML = this.generateHTML('full');
    
    if (targetContainer.id === 'discount-gamification-container-empty') {
      targetContainer.appendChild(this.container);
    } else {
      targetContainer.parentNode.insertBefore(this.container, targetContainer);
    }
  }
  
  createDrawerWidget() {
    // Observer pour détecter l'ouverture du panier latéral
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const drawer = mutation.target;
          if (drawer.hasAttribute('open') && !drawer.querySelector('.discount-gamification')) {
            this.insertDrawerWidget(drawer);
          }
        }
      });
    });
    
    // Observer le cart-drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, { attributes: true });
      
      // Si déjà ouvert, insérer immédiatement
      if (cartDrawer.hasAttribute('open')) {
        this.insertDrawerWidget(cartDrawer);
      }
    }
  }
  
  insertDrawerWidget(drawer) {
    const targetContainer = drawer.querySelector('#discount-gamification-drawer-empty') ||
                           drawer.querySelector('.cart-drawer__items') ||
                           drawer.querySelector('.cart-drawer__footer');
    
    if (!targetContainer || targetContainer.querySelector('.discount-gamification')) return;
    
    const widget = document.createElement('div');
    widget.className = 'discount-gamification discount-gamification--drawer';
    widget.innerHTML = this.generateHTML('compact');
    
    if (targetContainer.id === 'discount-gamification-drawer-empty') {
      targetContainer.appendChild(widget);
    } else if (targetContainer.classList.contains('cart-drawer__items')) {
      targetContainer.parentNode.insertBefore(widget, targetContainer.nextSibling);
    } else {
      targetContainer.parentNode.insertBefore(widget, targetContainer);
    }
  }
  
  createCollectionWidget() {
    // Insérer à la place du 3ème produit dans la grille
    const productGrid = document.querySelector('.product-list') || 
                       document.querySelector('.collection-grid') ||
                       document.querySelector('[data-products]');
    
    if (!productGrid) return;
    
    const products = productGrid.querySelectorAll('.product-card, .product-item');
    
    if (products.length >= 3) {
      const widget = document.createElement('div');
      widget.className = 'discount-gamification discount-gamification--collection product-card';
      widget.innerHTML = this.generateHTML('collection');
      
      // Insérer après le 2ème produit (à la place du 3ème)
      products[2].parentNode.insertBefore(widget, products[2]);
    }
  }
  
  createProductWidget() {
    // Widget compact sur la fiche produit
    const targetContainer = document.querySelector('.product-info') ||
                           document.querySelector('.product-form') ||
                           document.querySelector('.product-details');
    
    if (!targetContainer) return;
    
    const widget = document.createElement('div');
    widget.className = 'discount-gamification discount-gamification--product';
    widget.innerHTML = this.generateHTML('mini');
    
    // Insérer après le formulaire d'ajout au panier
    const addToCartForm = targetContainer.querySelector('form[action*="cart"]');
    if (addToCartForm) {
      addToCartForm.parentNode.insertBefore(widget, addToCartForm.nextSibling);
    } else {
      targetContainer.appendChild(widget);
    }
  }
  
  generateHTML(type = 'full') {
    const currentLevel = this.getCurrentLevel();
    const nextLevel = this.getNextLevel();
    const progress = this.getProgress();
    
    if (type === 'mini') {
      return `
        <div class="discount-mini">
          <div class="discount-mini__header">
            <span class="discount-mini__icon">🎁</span>
            <span class="discount-mini__text">Récompenses disponibles</span>
          </div>
          <div class="discount-mini__progress">
            <div class="discount-mini__progress-bar">
              <div class="discount-mini__progress-fill" style="width: ${progress}%"></div>
            </div>
            <div class="discount-mini__progress-text">
              ${this.cartTotal.toFixed(0)}€ / ${this.levels[this.levels.length - 1].threshold}€
            </div>
          </div>
          <div class="discount-mini__levels">
            ${this.levels.map(level => `
              <span class="discount-mini__badge ${level.color} ${this.cartTotal >= level.threshold ? 'active' : ''}" 
                    title="${level.name} - ${level.discount}% à partir de ${level.threshold}€">
                ${level.discount}%
              </span>
            `).join('')}
          </div>
          ${nextLevel ? `
            <div class="discount-mini__next">
              +${(nextLevel.threshold - this.cartTotal).toFixed(0)}€ pour ${nextLevel.discount}% de réduction
            </div>
          ` : ''}
        </div>
      `;
    }
    
    if (type === 'collection') {
      return `
        <div class="discount-collection">
          <div class="discount-collection__content">
            <div class="discount-collection__header">
              <div class="discount-collection__icon">🎮</div>
              <h3>Débloquez vos récompenses</h3>
              <p>Plus vous achetez, plus vous économisez</p>
            </div>
            <div class="discount-collection__levels">
              ${this.levels.map((level, index) => `
                <div class="discount-collection__level ${level.color}">
                  <span class="discount-collection__badge">${level.emoji}</span>
                  <div class="discount-collection__info">
                    <span class="discount-collection__name">${level.name}</span>
                    <span class="discount-collection__discount">${level.discount}%</span>
                  </div>
                  <span class="discount-collection__threshold">${level.threshold}€+</span>
                </div>
              `).join('')}
            </div>
            <div class="discount-collection__cta">
              <span>Commencez vos achats pour débloquer !</span>
            </div>
          </div>
        </div>
      `;
    }
    
    if (type === 'compact') {
      return `
        <div class="discount-compact">
          <div class="discount-compact__header">
            <span class="discount-compact__icon">🎁</span>
            <span class="discount-compact__title">Récompenses</span>
          </div>
          <div class="discount-compact__current">
            ${currentLevel ? `
              <div class="discount-compact__active">
                <span class="discount-compact__level">${currentLevel.name}</span>
                <span class="discount-compact__percent">${currentLevel.discount}%</span>
              </div>
            ` : `
              <div class="discount-compact__inactive">
                Aucune remise active
              </div>
            `}
          </div>
          ${nextLevel ? `
            <div class="discount-compact__next">
              +${(nextLevel.threshold - this.cartTotal).toFixed(0)}€ → ${nextLevel.name} ${nextLevel.discount}%
            </div>
          ` : ''}
        </div>
      `;
    }
    
    // Version complète pour la page panier
    return `
      <div class="discount-title">
        <span class="discount-icon">🎮</span>
        <h3>Débloquez vos récompenses !</h3>
      </div>
      
      <div class="discount-progress">
        <div class="discount-progress-bar">
          <div class="discount-progress-fill" style="width: ${progress}%"></div>
        </div>
        <div class="discount-levels">
          ${this.levels.map(level => `
            <div class="discount-badge ${level.color} ${this.cartTotal >= level.threshold ? 'active' : ''}" 
                 title="${level.name} - ${level.discount}% de réduction">
              <span class="discount-badge-emoji">${level.emoji}</span>
              <span class="discount-badge-name">${level.name}</span>
              <span class="discount-badge-percent">${level.discount}%</span>
            </div>
          `).join('')}
        </div>
      </div>
      
      <div class="discount-status">
        ${this.generateStatusMessage()}
      </div>
      
      <div class="discount-next">
        ${this.generateNextLevelMessage()}
      </div>
    `;
  }
  
  generateStatusMessage() {
    const currentLevel = this.getCurrentLevel();
    
    if (currentLevel) {
      const savings = (this.cartTotal * currentLevel.discount / 100).toFixed(2);
      let message = `
        <div class="discount-status-active">
          <strong>${currentLevel.discount}% de réduction !</strong><br>
          Niveau ${currentLevel.name} débloqué ! Vous économisez ${savings}€
      `;
      
      // Si des réductions sont déjà appliquées, l'indiquer clairement
      if (this.hasActiveDiscounts && this.finalCartTotal && this.finalCartTotal < this.cartTotal) {
        const actualSavings = (this.cartTotal - this.finalCartTotal).toFixed(2);
        message += `<br><small style="color: #28a745;">✅ Réduction déjà appliquée : -${actualSavings}€</small>`;
      }
      
      message += `</div>`;
      return message;
    } else {
      return `
        <div class="discount-status-inactive">
          <strong>Aucune remise active</strong><br>
          Ajoutez des produits pour débloquer vos récompenses !
        </div>
      `;
    }
  }
  
  generateNextLevelMessage() {
    const nextLevel = this.getNextLevel();
    
    if (nextLevel) {
      const remaining = (nextLevel.threshold - this.cartTotal).toFixed(2);
      return `
        <div class="discount-next-level">
          Plus que ${remaining}€ pour débloquer le niveau suivant !
        </div>
      `;
    } else {
      return `
        <div class="discount-max-level">
          🎉 Niveau maximum atteint ! Profitez de votre réduction !
        </div>
      `;
    }
  }
  
  getCurrentLevel() {
    return this.levels.slice().reverse().find(level => this.cartTotal >= level.threshold) || null;
  }
  
  getNextLevel() {
    return this.levels.find(level => this.cartTotal < level.threshold) || null;
  }
  
  getProgress() {
    if (this.cartTotal === 0) return 0;
    
    const maxThreshold = this.levels[this.levels.length - 1].threshold;
    return Math.min((this.cartTotal / maxThreshold) * 100, 100);
  }
  
  updateCartTotal() {
    // Récupérer le total depuis Shopify - UTILISER LE PRIX ORIGINAL pour les calculs de niveaux
    if (window.shopifyCartData) {
      // Utiliser le prix original (avant réductions) pour déterminer les niveaux de récompenses
      this.cartTotal = window.shopifyCartData.originalTotalPrice / 100;
      
      // Stocker aussi le prix final pour affichage des économies si nécessaire
      this.finalCartTotal = window.shopifyCartData.finalTotalPrice / 100;
      this.hasActiveDiscounts = window.shopifyCartData.hasDiscounts;
      this.totalDiscount = window.shopifyCartData.totalDiscount / 100;
    } else {
      // Fallback: chercher dans le DOM - priorité au prix original
      const originalTotalElement = document.querySelector('[data-cart-original-total]') ||
                                   document.querySelector('[data-original-total]');
      
      if (originalTotalElement) {
        const originalTotalText = originalTotalElement.textContent || originalTotalElement.innerText;
        const originalTotalMatch = originalTotalText.match(/(\d+(?:,\d+)?(?:\.\d+)?)/);
        if (originalTotalMatch) {
          this.cartTotal = parseFloat(originalTotalMatch[1].replace(',', '.'));
        }
      } else {
        // Fallback final: utiliser le total affiché (peut être après réduction)
        const totalElement = document.querySelector('[data-cart-total]') || 
                            document.querySelector('.cart-total') ||
                            document.querySelector('.order-summary__total');
        
        if (totalElement) {
          const totalText = totalElement.textContent || totalElement.innerText;
          const totalMatch = totalText.match(/(\d+(?:,\d+)?(?:\.\d+)?)/);
          if (totalMatch) {
            this.cartTotal = parseFloat(totalMatch[1].replace(',', '.'));
          }
        }
      }
    }
    
    this.updateDisplay();
  }
  
  updateDisplay() {
    const widgets = document.querySelectorAll('.discount-gamification');
    widgets.forEach(widget => {
      // Barres de progression principales
      const progressFill = widget.querySelector('.discount-progress-fill');
      if (progressFill) {
        progressFill.style.width = this.getProgress() + '%';
      }
      
      // Barres de progression mini (fiches produits)
      const miniProgressFill = widget.querySelector('.discount-mini__progress-fill');
      if (miniProgressFill) {
        miniProgressFill.style.width = this.getProgress() + '%';
      }
      
      // Texte de progression mini
      const miniProgressText = widget.querySelector('.discount-mini__progress-text');
      if (miniProgressText) {
        miniProgressText.textContent = `${this.cartTotal.toFixed(0)}€ / ${this.levels[this.levels.length - 1].threshold}€`;
      }
      
      // Badges
      const badges = widget.querySelectorAll('.discount-badge, .discount-mini__badge');
      badges.forEach((badge, index) => {
        const level = this.levels[index];
        if (level && this.cartTotal >= level.threshold) {
          badge.classList.add('active');
        } else if (level) {
          badge.classList.remove('active');
        }
      });
      
      // Messages de statut
      const statusDiv = widget.querySelector('.discount-status');
      if (statusDiv) {
        statusDiv.innerHTML = this.generateStatusMessage();
      }
      
      const nextDiv = widget.querySelector('.discount-next');
      if (nextDiv) {
        nextDiv.innerHTML = this.generateNextLevelMessage();
      }
      
      // Messages mini next
      const miniNext = widget.querySelector('.discount-mini__next');
      if (miniNext) {
        const nextLevel = this.getNextLevel();
        if (nextLevel) {
          miniNext.textContent = `+${(nextLevel.threshold - this.cartTotal).toFixed(0)}€ pour ${nextLevel.discount}% de réduction`;
        } else {
          miniNext.style.display = 'none';
        }
      }
      
      // Messages compact
      const compactCurrent = widget.querySelector('.discount-compact__current');
      if (compactCurrent) {
        const currentLevel = this.getCurrentLevel();
        if (currentLevel) {
          compactCurrent.innerHTML = `
            <div class="discount-compact__active">
              <span class="discount-compact__level">${currentLevel.name}</span>
              <span class="discount-compact__percent">${currentLevel.discount}%</span>
            </div>
          `;
        } else {
          compactCurrent.innerHTML = `
            <div class="discount-compact__inactive">
              Aucune remise active
            </div>
          `;
        }
      }
      
      const compactNext = widget.querySelector('.discount-compact__next');
      if (compactNext) {
        const nextLevel = this.getNextLevel();
        if (nextLevel) {
          compactNext.textContent = `+${(nextLevel.threshold - this.cartTotal).toFixed(0)}€ → ${nextLevel.name} ${nextLevel.discount}%`;
          compactNext.style.display = 'block';
        } else {
          compactNext.style.display = 'none';
        }
      }
    });
  }
  
  bindEvents() {
    // Écouter les événements Shopify
    document.addEventListener('cart:updated', (event) => {
      console.log('Cart updated event received');
      if (event.detail) {
        // Utiliser le prix original si disponible, sinon le prix total
        if (event.detail.original_total_price !== undefined) {
          this.cartTotal = event.detail.original_total_price / 100;
          this.finalCartTotal = event.detail.total_price / 100;
          this.hasActiveDiscounts = event.detail.total_discount > 0;
          this.totalDiscount = event.detail.total_discount / 100;
        } else {
          this.cartTotal = event.detail.total_price / 100;
        }
        this.updateDisplay();
      }
    });
    
    // Écouter les changements de quantité
    document.addEventListener('change', (event) => {
      if (event.target.matches('[name="quantity"]') || 
          event.target.matches('[data-quantity-input]')) {
        setTimeout(() => this.updateCartTotal(), 500);
      }
    });
    
    // Écouter les ajouts au panier
    document.addEventListener('product:added-to-cart', () => {
      setTimeout(() => {
        this.updateCartTotal();
        // Recréer le widget dans le drawer s'il s'ouvre
        const drawer = document.querySelector('cart-drawer[open]');
        if (drawer && !drawer.querySelector('.discount-gamification')) {
          this.insertDrawerWidget(drawer);
        }
      }, 1000);
    });
  }
}

// Initialisation globale
window.discountGamification = new DiscountGamification();

// Fonction utilitaire pour forcer la mise à jour
window.updateDiscountGamification = function() {
  if (window.discountGamification) {
    window.discountGamification.updateCartTotal();
  }
};

